import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root"
})
export class PersonaService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getPersona(tipoDocumento, numeroDocumento): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_PERSONA +
      "/" +
      tipoDocumento +
      "/" +
      numeroDocumento;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Persona",
            text: "Error Cargando Persona.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public getBusquedaPersona(busqueda): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_PERSONA + "/" + busqueda;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Persona",
            text: "Error Cargando Persona.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public getBusquedaPersonaTipoPerfil(busqueda, tipoPerfil): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_PERSONA +
      "/" +
      busqueda +
      "/tipoPerfil/" +
      tipoPerfil;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Persona",
            text: "Error Cargando Persona.",
            type: "error"
          });
        }
        return throwError(err);
      })
    );
  }

  public getPersonaXVehiculo(idPersona): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_PERSONA_VEHICULO + "/" + idPersona;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Persona Vehiculo",
            text: "Error Cargando Persona Vehiculo.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public getTipoPersonaXVehiculo(id): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_TIPO_PERSONA_VEHICULO + "/" + id;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Persona Vehiculo",
            text: "Error Cargando Tipo Persona Vehiculo.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public getPersonaDetalle(idPersona): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_PERSONA + "/" + idPersona + "/tipo/1";
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Persona",
            text: "Error Cargando Persona.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public postPersonaVehiculo(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_PERSONA_VEHICULO;
    return this.http.post<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Agencias",
            text: "Verifique la informacion ingresada.",
            type: "error",
            confirmButtonColor: "#127570"
          });
        }

        return throwError(err);
      })
    );
  }

  public putPersona(persona): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_PERSONA;
    return this.http.put<any>(url, persona).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Persona",
            text: "Error actualizando información de la persona.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public deletePersona(persona): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_PERSONA + "/" + persona;
    return this.http.delete<any>(url).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Persona",
            text: "Error eliminado información de la persona.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }
}
